import 'babel-polyfill';
import { createApp } from './app';

console.info('INIT ANIMATION');

const lang = document.documentElement.lang;
const version = (lang.indexOf('en') > -1) ? 'en' : 'fr';


const { app, store } = createApp(version);
store.dispatch('serverInit', version);

app.$mount('#app');

